import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccountBackComponent } from '../back/account-back.component';
@Component({
    selector: 'account-marketing-preferences',
    templateUrl: './account-marketing-preferences.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'c-9-set-x c-9-set-l c-8-set-m c-12-set-s m-b-0' },
    standalone: true,
    imports: [AccountBackComponent]
})
export class AccountMarketingPreferencesComponent {
}
